import { constructSearchQueryObject } from 'util/search'
import { buildSearchObject } from './buildSearchObject'

export function queryFor(valueMap, folder, mailbox) {
  const searchObject = buildSearchObject(folder, mailbox)
  return constructSearchQueryObject(searchObject, valueMap)
}
